var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlMountainViewOutlined = function SvgHtlMountainViewOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.494 13H1.5a.5.5 0 0 1 0-1h.69l1.38-2.758a1.284 1.284 0 0 1 1.536-.644c.193.062.368.169.512.312a.275.275 0 0 0 .357.032.277.277 0 0 0 .085-.096l1.637-3a1.48 1.48 0 0 1 1.307-.781 1.483 1.483 0 0 1 1.318.764l3.471 6.172h.708a.5.5 0 0 1 0 1h-1.006L13.494 13Zm-.848-1-3.2-5.682a.49.49 0 0 0-.439-.255.492.492 0 0 0-.436.26l-1.637 3a1.265 1.265 0 0 1-.94.653 1.267 1.267 0 0 1-1.086-.361.271.271 0 0 0-.36-.027.273.273 0 0 0-.082.099l-1.155 2.31 9.335.003ZM1 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm1 0a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z"
  })));
};
export default SvgHtlMountainViewOutlined;